import { useState, useEffect, useRef } from 'react'

const DEBOUNCE_MS = 400

export const useDebouncedFilter = onFilter => {
  const [filterValue, setFilterValue] = useState('')
  const debounceTimerRef = useRef(null)

  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current)
      }
    }
  }, [])

  const handleFilterChange = event => {
    const value = event.target.value
    setFilterValue(value)

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current)
    }

    debounceTimerRef.current = setTimeout(() => {
      onFilter(value)
    }, DEBOUNCE_MS)
  }

  return { filterValue, handleFilterChange }
}

const MESSAGE_FEEDBACK_REASONS = [
  "Didn't understand me",
  'Wrong specialty',
  'Wrong location',
  'Salary too low',
  'Irrelevant jobs',
  'Missing key criteria',
  'Inaccurate information',
  'Not helpful',
  'Other',
]

const POSITIVE_MESSAGE_FEEDBACK_REASONS = [
  'Relevant jobs',
  'Right specialty',
  'Good location',
  'Fair salary',
  'Understood my needs',
  'Helpful response',
  'Other',
]

const JOB_FEEDBACK_REASONS = [
  'Inaccurate match',
  'Wrong specialty',
  'Wrong location',
  'Salary mismatch',
  'Missing requirements',
  'Justification unclear',
  'Other',
]

const POSITIVE_JOB_FEEDBACK_REASONS = [
  'Match is accurate',
  'Good specialty fit',
  'Location is right',
  'Salary meets expectations',
  'Job criteria match',
  'Other',
]

export const getMessageFeedbackReasonLabel = (index, isPositive) => {
  const list = isPositive ? POSITIVE_MESSAGE_FEEDBACK_REASONS : MESSAGE_FEEDBACK_REASONS
  return list[index] ?? `Reason ${index}`
}

export const getJobFeedbackReasonLabel = (index, isPositive) => {
  const list = isPositive ? POSITIVE_JOB_FEEDBACK_REASONS : JOB_FEEDBACK_REASONS
  return list[index] ?? `Reason ${index}`
}

export const formatDate = dateString => {
  if (!dateString) return '-'
  return new Date(dateString).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
}

export const truncateText = (text, maxLength) => {
  if (!text) return ''
  if (text.length <= maxLength) return text
  return text.slice(0, maxLength) + '...'
}
